/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { HIGHCHARTS_DEFAULT_OPTIONS } from '../../../Chart.constants';
import { BarChartProps } from '../BarChart.props';

export const getBarChartAxisOptions = ({
  axisXLabel,
  axisXMaxValue,
  axisXMinValue,
  axisYMaxValue,
  axisYMinValue,
  axisYLabel,
  labelsOnXAxis,
  showLabelsOnXAxis,
  customXAxisLabelTemplate,
}: BarChartProps): Highcharts.Options => {
  const options: Highcharts.Options = { ...HIGHCHARTS_DEFAULT_OPTIONS };
  options.xAxis = {
    crosshair: false,
    labels: {
      align: 'left',
      enabled: showLabelsOnXAxis,
      reserveSpace: true,
      style: {
        whiteSpace: 'nowrap',
      },
    },
  };
  options.yAxis = {
    crosshair: false,
    lineColor: '#000',
    lineWidth: 1,
  };

  if (labelsOnXAxis) {
    options.xAxis.categories = labelsOnXAxis;
  }
  if (customXAxisLabelTemplate) {
    options.xAxis.labels = {
      ...options.xAxis.labels,
      formatter: function formatter(): string {
        return `${customXAxisLabelTemplate(this)}`;
      },
      useHTML: true,
    };
  }
  if (typeof axisXMinValue === 'number') {
    options.xAxis.min = axisXMinValue;
  }
  if (typeof axisXMaxValue === 'number') {
    options.xAxis.max = axisXMaxValue;
  }
  if (typeof axisYMinValue === 'number') {
    options.yAxis.min = axisYMinValue;
  }
  if (typeof axisYMaxValue === 'number') {
    options.yAxis.max = axisYMaxValue;
  }
  if (axisYLabel) {
    options.yAxis.title = {
      ...options.yAxis.title,
      align: 'middle',
      text: axisYLabel,
    };
  }
  if (axisXLabel) {
    options.xAxis.title = {
      ...options.xAxis.title,
      text: axisXLabel,
    };
  }
  return options;
};
